import React from "react";
import styled from "styled-components";
import device from "../helpers/device";
import noImage from "../img/noimage.png";

export default function({ speackers }) {
  return (
    <Speakers>
      {speackers.map(speaker => (
        <li key={speaker.id}>
          <div className="thumbnail">
            <img src={`/img/speakers/${speaker.id}.png`} alt="" />
          </div>
          <div className="data">
            <div className="division">{speaker.division}</div>
            <div className="name">{speaker.name}</div>
          </div>
        </li>
      ))}
    </Speakers>
  );
}

const Speakers = styled.ul`
  display: grid;
  grid-template-columns: 50% 50%;
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
  .data {
    padding: 0 10px;
    flex: 1;
  }
  .division {
    font-size: 10px;
    @media ${device.mobileL} {
      font-size: 12px;
    }
  }
  .name {
    font-size: 12px;
    font-weight: bold;
    @media ${device.mobileL} {
      font-size: 16px;
    }
  }
  .thumbnail {
    width: 68px;
    height: 68px;
    border-radius: 50%;
    overflow: hidden;
    background: url(${noImage}) no-repeat center center;
    background-size: cover;
    @media ${device.mobileL} {
      width: 90px;
      height: 90px;
    }
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
`;
